import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import StarOutlineIcon from '@material-ui/icons/StarOutline';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import ContactMailOutlinedIcon from '@material-ui/icons/ContactMailOutlined';


export const secondaryListItems = (
    <div>
        <ListItem button component={Link} to="/home">
            <ListItemIcon>
                <HomeOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
        </ListItem>
        <ListItem button component={Link} to="/about">
            <ListItemIcon>
                <InfoOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="About Me" />
        </ListItem>
        <ListItem button component={Link} to="/portfolio">
            <ListItemIcon>
                <StarOutlineIcon />
            </ListItemIcon>
            <ListItemText primary="Portfolio" />
        </ListItem>
        <ListItem button component={Link} to="/blog">
            <ListItemIcon>
                <CreateOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Blog" />
        </ListItem>
        <ListItem button component={Link} to="/contact">
            <ListItemIcon>
                <ContactMailOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Contact" />
        </ListItem>
    </div>
);